import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { NgxTippyModule } from 'ngx-tippy-wrapper';

import { AvatarModule } from 'src/app/components/avatar/avatar.module';
import { SearchablePopoverComponent } from 'src/app/components/searchable-popover/searchable-popover.component';
import { SharedPipesModule } from 'src/pipes/shared-pipes.module';

import { SuperAdminDeploymentsComponent } from './super-admin-deployments/super-admin-deployments.component';
import { SuperAdminRoutingModule } from './super-admin-routing.module';
import { CreateTenantModalComponent } from './super-admin-tenants/create-tenant-modal/create-tenant-modal.component';
import { SuperAdminTenantsComponent } from './super-admin-tenants/super-admin-tenants.component';
import { SuperAdminComponent } from './super-admin.component';

@NgModule({
  imports: [
    AvatarModule,
    CommonModule,
    FormsModule,
    IonicModule,
    NgxDatatableModule,
    SearchablePopoverComponent,
    SharedPipesModule,
    SuperAdminRoutingModule,
    NgxTippyModule,
  ],
  declarations: [
    SuperAdminComponent,
    SuperAdminTenantsComponent,
    SuperAdminDeploymentsComponent,
    CreateTenantModalComponent,
  ],
})
export class SuperAdminModule {}
